var map = {
	"./music-instructions.json": 4581,
	"./music-library-intro2024.json": 4582,
	"./music-library-launch2024.json": 4583,
	"./music-progression.json": 4584,
	"./startSourcesAdvanced.json": 4585,
	"./startSourcesSimple.json": 4586,
	"./startSourcesSimple2.json": 4587,
	"./startSourcesTracks.json": 4588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4349;